import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { CircularProgress } from 'src/components/UI/CircularProgress.tsx';
import { UIAlert } from 'src/components/UI/UIAlert.tsx';
import { API_AGENTS_URL } from 'src/configs/api.config.ts';
import { useViewportSize } from 'src/hooks/useVieportSize.ts';
import { SwapTokens } from 'src/pages/agents/[agentId]/components/SwapTokens.tsx';
import { Agent } from 'src/types/agents.ts';
import { AgentBanner } from './components/AgentBanner.tsx';
import { AgentInfo } from './components/AgentInfo.tsx';
import { BondingCurve } from './components/BondingCurve.tsx';
import { Chat } from './components/chat/Chat.tsx';
import { Tabs } from './components/tabs/Tabs.tsx';
import { UniSwapTrade } from './components/UniSwapTrade.tsx';

export const AgentsIdPage = () => {
  const { agentId } = useParams();

  const { width } = useViewportSize();

  const { isFetching, data, isError } = useQuery({
    queryKey: ['agents'],
    queryFn: () =>
      axios.get<Agent>(`${API_AGENTS_URL}/api/agents/${agentId}`).then((res) => res.data),
    refetchOnWindowFocus: false,
  });

  if (isFetching || !data)
    return (
      <div className="flex flex-col items-center justify-center">
        <div className="mb-4 h-4 w-4">
          <CircularProgress spinnerSize="full" className="fill-white" />
        </div>
        <span>Loading...</span>
      </div>
    );
  if (isError) return <UIAlert type="error" message="Error while loading agent data" />;

  return (
    <div className="flex w-full flex-grow flex-col gap-3 pb-6">
      <AgentBanner agent={data} />
      <AgentInfo agent={data} />
      <div className="grid flex-grow grid-cols-1 gap-3.5 md:grid-cols-2 xl:grid-cols-3">
        <div className="col-span-1 flex flex-col gap-3.5 md:col-span-2">
          <BondingCurve agent={data} />
          <Tabs agent={data} />
        </div>
        {width > 1280 ? (
          <div className="flex flex-col gap-3">
            {data.token_info?.updated_token_address ? (
              <UniSwapTrade agent={data} />
            ) : (
              <SwapTokens agent={data} />
            )}
            <Chat agent={data} />
          </div>
        ) : (
          <>
            {data.token_info?.updated_token_address ? (
              <UniSwapTrade agent={data} />
            ) : (
              <SwapTokens agent={data} />
            )}
            <Chat agent={data} />
          </>
        )}
      </div>
    </div>
  );
};
